import { Container, ListItem, Typography } from "@mui/material";

export function Shipping() {
  return (
    <Container sx={{mb: 30}}>
      <Typography variant="h6" sx={{mb: 2}}>
          How much do you charge for shipping?
      </Typography>
      <Typography variant="body1">
          New Zealand
      </Typography>
      <ListItem sx={{ display: 'list-item' }}>
          Courier post with signature required - $10.20 NZD
      </ListItem>
      <ListItem sx={{ display: 'list-item' }}>
          Courier post –  $7.20 NZD
      </ListItem>
      <ListItem sx={{ display: 'list-item', mb: 2 }}>
          A $5 surcharge applies to all NZ rural addresses, even with more than one product.
      </ListItem>

      <Typography variant="body1" sx={{mb: 2}}>
          International
      </Typography>
      <ListItem sx={{ display: 'list-item' }}>
          Australia - $40 NZD
      </ListItem>
      <ListItem sx={{ display: 'list-item' }}>
          Other countries – If wishing to purchase from outside New Zealand and Australia please get in touch so shipping can be arranged.
      </ListItem>

    </Container>
  )
}